import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';

const auth0_audience = 'Tyx_OrderHarness_API';
const auth0_cacheLocation = 'localstorage';

export function provideAuth0Module() {
    return importProvidersFrom(
        BrowserAnimationsModule,
        AuthModule.forRoot({
            domain: environment.auth0.domain,
            clientId: environment.auth0.clientId,
            cacheLocation: auth0_cacheLocation,
            authorizationParams: {
                redirect_uri: environment.auth0.redirectUri + '',
                audience: auth0_audience,
            },
            httpInterceptor: {
                allowedList: [
                    {
                        uri: `${environment.apiUrl}/*`,
                        tokenOptions: {
                            authorizationParams: {
                                audience: auth0_audience,
                            },
                        },
                    },
                    {
                        uri: `${environment.seqApiUrl}/*`,
                        tokenOptions: {
                            authorizationParams: {
                                audience: auth0_audience,
                            },
                        },
                    },
                ],
            },
        })
    );
}
